__turbopack_context__.v({
  "navbarBackground": "Navbar-module-scss-module__nouA-W__navbarBackground",
});
